var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 97,
    viewBox: "0 0 75 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3994 3V3C44.8183 3 47.1381 3.96134 48.848 5.67235L69.7932 26.6315C71.2599 28.0992 72.0838 30.0892 72.0838 32.1641V32.1641M42.3994 3H12.595C7.2958 3 3 7.29582 3 12.595V83.5978C3 88.8969 7.29582 93.1927 12.595 93.1927H62.4888C67.788 93.1927 72.0838 88.8969 72.0838 83.5978V32.1641M42.3994 3V22.5691C42.3994 27.8683 46.6952 32.1641 51.9943 32.1641H72.0838",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.2e099c6035eb3805e168b5637a6b6aa5.svg";
export { ForwardRef as ReactComponent };